import { render, staticRenderFns } from "./DashboardClientClaim.vue?vue&type=template&id=3b440106&"
import script from "./DashboardClientClaim.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientClaim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b440106')) {
      api.createRecord('3b440106', component.options)
    } else {
      api.reload('3b440106', component.options)
    }
    module.hot.accept("./DashboardClientClaim.vue?vue&type=template&id=3b440106&", function () {
      api.rerender('3b440106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientClaim.vue"
export default component.exports